import useResources from "./use-resources";

export default function useAdminFactures() {
  const {
    resources: factures,
    isLoading,
    error,
    create: generateFacture,
  } = useResources("/admin/factures");

  return { factures, isLoading, error, generateFacture };
}
